document.addEventListener("DOMContentLoaded", function() {
    const seeMoreButton = document.querySelector('.see-more-button');
    const toggleText = seeMoreButton.querySelector('.toggle-text');
    const chevron = seeMoreButton.querySelector('.circle-chevron');
    const expandableContent = document.querySelector('.expandable-content');

    const seeMoreText = toggleText.textContent;
    const seeLessText = toggleText.dataset.seelesstext;

    seeMoreButton.addEventListener('click', function() {
        if (toggleText.textContent === seeMoreText) {
            toggleText.textContent = seeLessText;
            expandableContent.classList.add('show-content');
        } else {
            toggleText.textContent = seeMoreText;
            expandableContent.classList.remove('show-content');
        }
    });
});

// JavaScript function to open the pop-up
function openPopupDrawer(text, cart) {

    var popup = document.getElementById("popupOverlay");
    popup.style.display = "flex";
    popup.querySelector(".popup").scrollTo(0, 0);
    document.querySelector("body").style.overflow = "hidden";
    if (text == "contribe") {
        popup.querySelector(".contribe-content").style.display = "block";
    } else if (text == "subscription") {
        popup.querySelector(".subscription-content").style.display = "block";
    }
}

// JavaScript function to close the pop-up
function closePopup(cart) {
    var popup = document.getElementById("popupOverlay");
    popup.style.display = "none";
    document.querySelector("body").style.overflow = "auto";
    popup.querySelector(".contribe-content").style.display = "none";
    popup.querySelector(".subscription-content").style.display = "none";
}

if (document.querySelector(".info-text")) {
    document.querySelector(".info-text").addEventListener("click", ()=>openPopupDrawer('subscription'));
}

if (document.getElementById("popupOverlay")) {
    document.getElementById("popupOverlay").addEventListener("click", closePopup);
}

function changeSubscription(input_field) {
    if (input_field.checked) {

    console.log("checked");
    document.querySelector(".subscription-offer").classList.add("active");

    const id = 47758049968425;
    const sellingPlan = 692770439465;
    const url = `/cart/change.js?id=${id}&selling_plan=${sellingPlan}`;
    fetch(url, { method: "POST" })
        .then((response) => {
        return response.json();
        })
        .then((data) => {
        const cartRefreshEvent = new CustomEvent("cart:refresh");
        document.dispatchEvent(cartRefreshEvent);
        })
        .catch((error) => {
        alert("Udsolgt")
        console.error("Error:", error);
        });
    } else {
        document.querySelector(".subscription-offer").classList.remove("active");
        const id = 47758049968425;
        const sellingPlan = "null";
        const url = `/cart/change.js?id=${id}&selling_plan`;
        fetch(url, { method: "POST" })
        .then((response) => {
            return response.json();
        })
        .then((data) => {
            const cartRefreshEvent = new CustomEvent("cart:refresh");
            document.dispatchEvent(cartRefreshEvent);
        })
        .catch((error) => {
            alert("Udsolgt")
            console.error("Error:", error);
        });
        
    }
}

// function upsellFilter() {
    
//     const addProductId = 49465098043689;
//     const productProperties = {
//         "Et års forbrug": "4 x MILO Filter"
//     };
//     const addProductUrl = `/cart/add.js?id=${addProductId}`;
    
//     fetch(addProductUrl, {
//             method: "POST",
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({
//                 id: addProductId,
//                 quantity: 1,
//                 properties: productProperties
//             })
//         })
//         .then((response) => response.json())
//         .then(() => {
//             // Step 4: Refresh the cart
//             const cartRefreshEvent = new CustomEvent("cart:refresh");
//             document.dispatchEvent(cartRefreshEvent);
//         })
//         .catch((error) => {
//             alert("An error occurred while processing your request.");
//             console.error("Error:", error);
//         });
// }


function upgradeToSubscription() {
    console.log("clicked");

    const removeProductId = 47694626226473;
    const addProductId = 49053825761577;
    const subscriptionProductId = 47758204666153;
    const sellingPlanId = 692725711145;

    const productProperties = {
        "Inklusiv MILO Filter": "holder 3 mdr."
    };

    // Step 1: Remove the product with id = 47694626226473
    const removeUrl = `/cart/change.js?line=1&quantity=0&id=${removeProductId}`;
    
    fetch(removeUrl, { method: "POST" })
        .then((response) => response.json())
        .then(() => {
            // Step 3: Add the product with selling plan
            const subscriptionUrl = `/cart/add.js?id=${subscriptionProductId}&selling_plan=${sellingPlanId}`;
            return fetch(subscriptionUrl, { method: "POST" });
        })
        .then((response) => response.json())
        .then(() => {
            // Step 2: Add the product with id = 49053825761577
            const addProductUrl = `/cart/add.js?id=${addProductId}`;
            return fetch(addProductUrl, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: addProductId,
                    quantity: 1,
                    properties: productProperties
                })
            });
        })
        .then((response) => response.json())
        .then(() => {
            // Step 4: Refresh the cart
            const cartRefreshEvent = new CustomEvent("cart:refresh");
            document.dispatchEvent(cartRefreshEvent);
        })
        .catch((error) => {
            alert("An error occurred while processing your request.");
            console.error("Error:", error);
        });
}

function handleRemoveSubscription() {
    // First fetch request to remove the first item
    fetch('/cart/change?id=47758204666153&quantity=0', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
    })
    .then(data => {
      console.log('First item removed:', data);

      // Second fetch request to remove the second item
      return fetch('/cart/change?id=49053825761577&quantity=0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });
    })
    .then((response) => {
    })
    .then(() => {
      const cartRefreshEvent = new CustomEvent("cart:refresh");
      document.dispatchEvent(cartRefreshEvent);
      location.reload();
    })
    .catch((error) => {
        console.log("An error occurred while processing your request.");
        console.log("Error:", error);
    });
  }